window.addEventListener("DOMContentLoaded", async () => {
  // get refererId
  const url = new URL(window.location);
  const urlSearch = new URLSearchParams(url.search);
  const refererId = urlSearch.get("referer_id");
  console.log("Get refererId", refererId);

  // 如果是 landing page 就不顯示 popup
  if (window.page_template_suffix === "landing") {
    window.popup_automatically_show = false;
    document.getElementById("popup-button").style.display = "none";
  }

  // Show zendesk launcher
  if (window.enable_zendesk) {
    if (document.getElementById("zendesk_launcher")) {
      document
        .getElementById("zendesk_launcher")
        .addEventListener("click", () => {
          zE("messenger", "open");
        });
    }
  }

  // 一般的 popup
  if (
    window.popup_type != "none" &&
    window.popup_type != "zendesk" &&
    !window.page_template_suffix.includes("referral") &&
    !window.page_template_suffix.includes("empty")
  ) {
    if (document.getElementById("popup-close")) {
      document.getElementById("popup-close").addEventListener("click", () => {
        hidePopup();
      });
    }
    if (document.getElementById("popup-button")) {
      document.getElementById("popup-button").addEventListener("click", () => {
        gtag("send", "event", "button", "clicks", "whole-popup-open");
        gtag("send", "event", "pop-up", "views", "whole-popup-join");
        document.getElementById("popup").classList.add("popup-active");
      });
    }

    const popup = document.getElementById("popup");
    function showPopup() {
      popup.classList.add("popup-active");
    }
    function hidePopup() {
      popup.classList.remove("popup-active");
    }

    function firstTimeShowPopupFn() {
      setTimeout(() => {
        sessionStorage.setItem("showTimes", "1");
        showPopup();
      }, 20000);
    }

    // Parse URL (If url has openpopup)
    if (window.location.href.includes("openpopup")) {
      showPopup();
    }

    // 如果 popup_automatically_show 為 true 就倒數 20s 開 popup
    if (window.popup_automatically_show) {
      if (sessionStorage.getItem("showTimes") !== "1") {
        firstTimeShowPopupFn();
      }
    }
  } else {
    console.log("popup_type", window.popup_type);
  }

  // referral popup
  if (document.getElementById("referral-popup")) {
    const referralPopup = document.getElementById("referral-popup");
    function showReferralPopup() {
      referralPopup.classList.add("referral-popup-active");
    }
    function hideReferralPopup() {
      referralPopup.classList.remove("referral-popup-active");
      if (window.popup_automatically_show) {
        firstTimeShowPopupFn();
      }
    }
    document
      .getElementById("referral-popup-close")
      .addEventListener("click", hideReferralPopup);
  }

  // 透過 refererId 拿到 coupon code
  if (refererId) {
    const countryEl = document.getElementById("shop_domain");
    const country =
      countryEl.dataset.country === "cu"
        ? "cubo-test"
        : countryEl.dataset.country;
    const res = await document.cuboReferral.initReferee(country);
    console.log("referer Info", res);
    sessionStorage.setItem("coupon_code", res.coupon.code);

    // 將 coupon code 放到 referral-coupon 上
    if (document.getElementById("referral-coupon")) {
      document.getElementById("referral-coupon").textContent =
        sessionStorage.getItem("coupon_code");
    }

    // referral 頁面不需要顯示 popup
    if (!window.page_template_suffix.includes("referral") && refererId) {
      showReferralPopup();
    }
  }
});
